import { useEffect, useState } from "react";
import IMAGES from "../../../../assets/images/images";
import { WIDGET_NAME } from "../../../../utils/constants/homeConstants";
import styles from "./customerdetail.module.css"
import { FUNCTIONAL_ROLES_CONSTANTS } from "../../../../utils/constants/userConstants";
import { connect } from "react-redux";
import { getCustomerData, getCustomerPrimaryContact, getSelectedCustAM, getSelectedCustApprover } from "../../../../redux/actions/home/home.action";
import Shimmer from "../../../../components/shimmer/Shimmer";
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip";
import moment from "moment";
import EmptyDataView from "../../../../components/emptydataview/EmptyDataView";
const CustomerDetail = ({action,myRights,selectedCustomerId,...props}) => {
const customerData = props?.customerData || {};
const list = action===WIDGET_NAME.CUSTOMER_PRIMARY_CONTACT_DETAILS_WIDGET? props?.customerPrimaryContact || {}: 
action===WIDGET_NAME.ACCOUNT_MANAGERS_LIST_WIDGET? props?.selectedCustomerAM || {} :
action===WIDGET_NAME.CUSTOMER_APPROVER_DETAILS_WIDGET? props?.selectedCustomerApprover || {} : {}
const [currentIndex, setCurrentIndex] = useState(0);
const [isCopied, setIsCopied] = useState(false);

const handleNext = () => {
  if (currentIndex < list?.details?.length - 1) {
    setCurrentIndex(currentIndex + 1);
  }
};

const handlePrevious = () => {
  if (currentIndex > 0) {
    setCurrentIndex(currentIndex - 1);
  }
};

const handleCopy = (text) => {
  navigator.clipboard.writeText(text);
  setIsCopied(true);
};

const handleMouseLeave = () => {
  setIsCopied(false);
};
useEffect(()=>{
  if(action===WIDGET_NAME.CUSTOMER_DETAILS_WIDGET && selectedCustomerId){
    props?.getCustomerData(action,"",selectedCustomerId);
  }
  if(action===WIDGET_NAME.CUSTOMER_PRIMARY_CONTACT_DETAILS_WIDGET && selectedCustomerId){
    props?.getCustomerPrimaryContact(action,"",selectedCustomerId);
  }
  if(action===WIDGET_NAME.ACCOUNT_MANAGERS_LIST_WIDGET && selectedCustomerId){
    props?.getSelectedCustAM(action,"",selectedCustomerId);
  }
  if(action===WIDGET_NAME.CUSTOMER_APPROVER_DETAILS_WIDGET && selectedCustomerId){
    props?.getSelectedCustApprover(action,"",selectedCustomerId);
  }
  setCurrentIndex(0);
},[selectedCustomerId])

const handleRetry = (type) => {
  const retryActions = {
  [WIDGET_NAME.CUSTOMER_DETAILS_WIDGET]: props.getCustomerData,
  [WIDGET_NAME.CUSTOMER_PRIMARY_CONTACT_DETAILS_WIDGET]: props.getCustomerPrimaryContact,
  [WIDGET_NAME.ACCOUNT_MANAGERS_LIST_WIDGET]: props.getSelectedCustAM,
  [WIDGET_NAME.CUSTOMER_APPROVER_DETAILS_WIDGET]: props.getSelectedCustApprover,
  };

  const retryFn = retryActions[type];
  if (retryFn) {
  retryFn(type,"",selectedCustomerId);
  }
};
const shouldShowRetry = (
  (action === WIDGET_NAME.CUSTOMER_DETAILS_WIDGET && !props?.isLoading && customerData && Object.keys(customerData)?.length===0) ||
  (action === WIDGET_NAME.CUSTOMER_PRIMARY_CONTACT_DETAILS_WIDGET && !props?.custPCLoading && list && (!Array.isArray(list?.details) || list.details.length === 0)) ||
  (action === WIDGET_NAME.ACCOUNT_MANAGERS_LIST_WIDGET && !props?.selectedCustAmLoading && list && (!Array.isArray(list?.details) || list.details.length === 0)) ||
  (action === WIDGET_NAME.CUSTOMER_APPROVER_DETAILS_WIDGET && !props?.customerApproverLoading && list && (!Array.isArray(list?.details) || list.details.length === 0))
);
    return(
      props?.isLoading && action===WIDGET_NAME.CUSTOMER_DETAILS_WIDGET ? <Shimmer/> :
      props?.custPCLoading && action ===WIDGET_NAME.CUSTOMER_PRIMARY_CONTACT_DETAILS_WIDGET? <Shimmer/> :
      props?.selectedCustAmLoading && action ===WIDGET_NAME.ACCOUNT_MANAGERS_LIST_WIDGET? <Shimmer/> :
      props?.customerApproverLoading && action ===WIDGET_NAME.CUSTOMER_APPROVER_DETAILS_WIDGET? <Shimmer/> :
      <div className={styles.detailslayout}>
        <div className={styles.header}>
          <div className={styles.custheader}>{action===WIDGET_NAME.CUSTOMER_DETAILS_WIDGET?"Customer Details":action===WIDGET_NAME.CUSTOMER_PRIMARY_CONTACT_DETAILS_WIDGET?"Customer Primary Contact":action===WIDGET_NAME?.ACCOUNT_MANAGERS_LIST_WIDGET?"Vodafone Point of Contact":action===WIDGET_NAME.CUSTOMER_APPROVER_DETAILS_WIDGET?"Approved By":""}</div>
          {shouldShowRetry&&
          <div className={styles.retryparent} onClick={()=>handleRetry(action)}> <div className={styles.retryicon}></div><div className={styles.refresh}>Refresh</div></div>
          }
        </div>
        {action===WIDGET_NAME.CUSTOMER_DETAILS_WIDGET?
        Object.keys(customerData)?.length===0 ? <div className={styles.emptywrapper}><EmptyDataView/></div> :
        <div className={styles.custbody}>
          <div className={styles.servicecontainer}>
            <div className={styles.label}>Service Type</div>
            <div className={styles.value}>{customerData?.customerDetails?.serviceType?.label}</div>
          </div>
          <div className={styles.onboardedcontainer}>
            <div className={styles.label}>Approved On</div>
            <div className={styles.value}>{moment(customerData?.customerDetails?.approvedAt* 1000).format("DD MMM YYYY")}</div>
          </div>
          {(myRights?.functionalRoles[0] === FUNCTIONAL_ROLES_CONSTANTS["account_manager_internal"]?.value||myRights?.functionalRoles[0] === FUNCTIONAL_ROLES_CONSTANTS["super_admin_internal"]?.value)&&
            <div className={styles.onboardedcontainer}>
              <div className={styles.label}>Approved by</div>
              <SecondaryTooltip text={customerData?.customerDetails?.approvedBy?.email} positions={['bottom', 'right']} copy={true}>
                <div className={styles.value}>{customerData?.customerDetails?.approvedBy?.name}</div>
              </SecondaryTooltip>
            </div>
          }
        </div>
        :
        <>
        {!Array.isArray(list?.details) || list.details.length === 0  ? <div className={styles.emptywrapper}><EmptyDataView/></div>:
      <div className={styles.listbodywrapper}>
        {currentIndex > 0 && ( <span className={`${styles.leftarrow} ${styles.arrowparent}`} onClick={handlePrevious}> <img src={IMAGES.montharrow} className={styles.arrowicon} alt="Previous"/></span>)}
        <div className={styles.listbody}>
            <img src={IMAGES.usericon} className={styles.usericon} alt="User Icon"/>
            <div className={styles.wrapper}>
              <div className={styles.name}>{list?.details[currentIndex]?.name}</div>
              <div className={styles.email}>
                <span className={styles.emailtext}>{list?.details[currentIndex]?.email}</span>
                <span className={styles.imgwrapper}>
                  <img src={isCopied ? IMAGES.success : IMAGES.copy} className={styles.copy} onClick={() => handleCopy(list?.details[currentIndex]?.email)} onMouseLeave={handleMouseLeave} alt="Copy" />
                </span>
              </div>
            </div>
        </div>
        {currentIndex < list?.details?.length - 1 && (<span className={`${styles.rightarrow}  ${styles.arrowparent}`} onClick={handleNext}> <img src={IMAGES.montharrow} className={styles.arrowicon} alt="Next"/></span>)}
      </div>}
      {list?.details?.length>1&&(
      <div className={styles.dotPagination}>
        {list?.details?.map((_, index) => (
            <span key={index} className={`${styles.dot} ${currentIndex === index ? styles.activeDot : ''}`} onClick={() => setCurrentIndex(index)}/>
        ))}
      </div>
      )}
        </>
        }
      </div>
    )
  }

const mapStateToProps = (state) => {
  return {
    customerData:state?.dashBoardCounts?.customerData?.data,
    isLoading:state?.dashBoardCounts?.customerData?.isLoading,
    customerPrimaryContact: state?.dashBoardCounts?.customerPrimaryContact?.data,
    custPCLoading:state?.dashBoardCounts?.customerPrimaryContact?.isLoading,
    selectedCustomerAM: state?.dashBoardCounts?.selectedCustomerAM?.data,
    selectedCustAmLoading: state?.dashBoardCounts?.selectedCustomerAM?.isLoading,
    selectedCustomerApprover: state?.dashBoardCounts?.selectedCustomerApprover?.data,
    customerApproverLoading: state?.dashBoardCounts?.selectedCustomerApprover?.isLoading,
    myRights : state.myRights.myRights,
  }
}
const mapDispatchToProps = (dispatch)=>{
  return {
    getCustomerData: (action,filterOptions="",selectedCustomerId="") => {
        return dispatch(getCustomerData(action,filterOptions,selectedCustomerId))
    },
    getCustomerPrimaryContact: (action, filterOptions="",selectedCustomerId="") => {
      return dispatch(getCustomerPrimaryContact(action,filterOptions,selectedCustomerId))
    },
    getSelectedCustAM: (action,filterOptions="",selectedCustomerId="") => {
      return dispatch(getSelectedCustAM(action,filterOptions,selectedCustomerId))
    },
    getSelectedCustApprover: (action,filterOptions="",selectedCustomerId="") => {
      return dispatch(getSelectedCustApprover(action,filterOptions,selectedCustomerId))
    },
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(CustomerDetail);